export default "__VITE_ASSET__CGXBO1yg__"